export enum ProjectStatus {
	late = 'late',
	minorDelay = 'minorDelay',
	onTrack = 'onTrack',
	noDataAvailable = 'noDataAvailable',
}
